import apiV2 from '../api/v2';

// Global (not practice-scoped) communication counts, backed by GET
// /practices/communications/summary. Powers both the Accounts Overview hub's
// stat row and the Communications page's status cards.
export interface CommunicationsSummaryWeek {
    total: number;
    incoming: number;
    outgoing: number;
}

export interface CommunicationsSummary {
    week: CommunicationsSummaryWeek;
    // The 7 days before `week`, so the page can show a delta.
    priorWeekTotal: number;
    unresolved: number;
    resolved: number;
    // Threads with no practice - logged before the practice was identified.
    unassigned: number;
    // Open threads nobody owns yet: the triage queue.
    unassignedOpen: number;
    // Open threads assigned to the current user. Null when the server could
    // not resolve the caller - rendered as a dash, never as a zero.
    assignedToMeOpen: number | null;
}

export async function fetchCommunicationsSummary(): Promise<CommunicationsSummary> {
    const response = await apiV2.get<{ success: boolean; data: CommunicationsSummary }>(
        '/practices/communications/summary'
    );
    return response.data.data;
}
